const endpoints = {
  listPolicies: (): string => `policy`,
};

export default endpoints;
